import type * as React from "react"

import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/empty"
import { cn } from "@/lib/utils"

type EmptyStateProps = React.ComponentProps<typeof Empty> & {
  title: string
  description?: string
  icon?: React.ReactNode
  actions?: React.ReactNode
  size?: "default" | "compact"
}

function EmptyState({
  className,
  title,
  description,
  icon,
  actions,
  size = "default",
  ...props
}: EmptyStateProps) {
  return (
    <Empty
      data-slot="empty-state"
      data-size={size}
      className={cn(
        size === "compact" &&
          "min-h-44 border border-border/60 bg-muted/10 p-6",
        className
      )}
      {...props}
    >
      <EmptyHeader>
        {icon ? <EmptyMedia variant="icon">{icon}</EmptyMedia> : null}
        <EmptyTitle>{title}</EmptyTitle>
        {description ? (
          <EmptyDescription>{description}</EmptyDescription>
        ) : null}
      </EmptyHeader>
      {actions ? <EmptyContent>{actions}</EmptyContent> : null}
    </Empty>
  )
}

export { EmptyState }
